import { useDispatch, useSelector } from 'react-redux'
import page_img from '../../components/Navigation/icons/verifica.svg'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

import { Stepper, Step } from 'react-form-stepper';

import add_img from '../../assets/images/add.svg'
import arrow_back_img from '../../assets/images/arrow-back.svg'

import arrow_img from '../../assets/images/arrow-right.svg'

import { toast } from 'react-toastify';

import './Exams.css'
import TrainingInfo from './_components/TrainingInfo';
import { fetchAddQuestionsModules, fetchCreateExam, fetchCreateTraining, fetchEditExam, fetchExam, fetchGetFolder } from './TrainingApi';
import { setLoading } from '../../services/global/globalSlice';
import TrainingQuestion from './_components/TrainingQuestion';
import { prepareModules } from '../../utils/questions';
import ConfirmModal from '../../components/_modals/ConfirmModal';

export default function TrainingDetailScreen(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [activeStep, setActiveStep] = useState(0)
    const [trainingData, setTrainingData] = useState({})
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const {folder_id} = useParams()


    const handleTrainingDataChange = (data) => {
        setTrainingData(data)
    }

    const handleCreateDraft = async () => {
        const _trainingData = structuredClone(trainingData)
        _trainingData["num_questions_per_training"] = parseInt(_trainingData["num_questions_per_training"])
        const response = await fetchCreateTraining({folder_id:folder_id}, _trainingData)
        if(response.success){
            dispatch(setLoading(false))
            return 'ok'
        } else {
            toast.error(t.exam.error_saving_exam)
            dispatch(setLoading(false))
        }
    }

    const handleSaveDraft = async () => {
        if(!trainingData?.num_questions_per_training || parseInt(trainingData?.num_questions_per_training) < 1){          
            toast.error(t.training.missing_questions)
            return;
        }
        const _trainingData = structuredClone(trainingData)
        const response = await fetchCreateTraining({folder_id:folder_id}, _trainingData)
        if(response.success){
            toast.success(t.training.draft_saved)
            dispatch(setLoading(false))
            return 'ok'
        } else {
            toast.error(t.exam.error_saving_exam)
            dispatch(setLoading(false))
        }
    }

    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const handlePubblishTraining = async (_,force = false) => {
        if(!trainingData?.num_questions_per_training || parseInt(trainingData?.num_questions_per_training) < 1){          
            toast.error(t.training.missing_questions)
            return;
        }
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.publish_title,
                text: t.exam.publish_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handlePubblishTraining(true,true),
                confirmCta: t.exam.publish_cta,
                closeCta: t.modals.no_exit,
            })
        } else {
            closeConfirmModal()
            let _trainingData = structuredClone(trainingData)
             _trainingData['ready'] = true
            const response = await fetchCreateTraining({folder_id:folder_id}, _trainingData)
            if(response.success){
                toast.success(t.training.traininig_saved)
                dispatch(setLoading(false))
                navigate(`/folder/${folder_id}`)
                return 'ok'
            } else {
                toast.error(t.training.error_saving)
                dispatch(setLoading(false))
            }
        }
    }

    const handleNextStep = () => {
        switch(activeStep){
            case 0:
                if(trainingData.training_title && trainingData.description){
                    if(trainingData?.num_questions_per_training && parseInt(trainingData?.num_questions_per_training) >= 1){
                        dispatch(setLoading(true))
                        handleCreateDraft().then(()=>{
                            setActiveStep(1)
                        })
                    } else {
                        toast.error(t.training.missing_questions)
                        return;
                    }
                } else {
                    toast.error(t.exam.missing_title_description)
                }
            break;
            case 1:
                handlePubblishTraining()
            break;
        }
    }

    const checkDisabled = () => {
        switch(activeStep){
            case 0: 
                if(!trainingData.training_title)
                    return true
            break;
            case 1: 
                if(trainingData?.questions?.length === 0)
                    return true
            break;
            default:
                return false
        }
    }

    const loadFolderData = async ( ) => {
        const _folder_id = trainingData.folder_id || folder_id 
        const response =  await fetchGetFolder({folder_id:_folder_id})
        if(response.success){
            if(response.data?.training){
                setTrainingData({...response.data?.training, folder_id: folder_id})
            } 
            else
                setTrainingData({
                    questions:[],
                    training_title: "",
                    description: "",
                    num_questions_per_training: 7,
                    ready: false,
                    folder_id: folder_id,
                    required_correct_answers: 2
                })
            dispatch(setLoading(false))
        } else {
            console.error("error")
        }
    }

    useEffect(()=>{
        if(!props.isNew){
            dispatch(setLoading(true))
            loadFolderData()
        } else {
            setTrainingData({
                training_title: "",
                description: "",
                num_questions_per_training: 7,
                ready: false,
                folder_id: folder_id,
                required_correct_answers: 2
            })
        }
    },[folder_id])

    return (
        <section>
            <>
                <Link to={folder_id ? `/folder/${folder_id}`: '/'}>
                    <img src={arrow_back_img} alt=''/>
                    <span>{t.buttons.back}</span>
                </Link>
            </>
            <Stepper 
                activeStep={activeStep}
                styleConfig={{
                    activeBgColor: "#436094",
                    completedBgColor: "#436094",
                    inactiveBgColor: "#E2E2E2"
                }}
                nonLinear={!props.isNew}
            >
                <Step label={t.training.info}  onClick={()=>setActiveStep(0)}/>
                <Step label={t.training.questions} onClick={()=>setActiveStep(1)}/>
                
            </Stepper>
            <div className='container'>
              {
                    trainingData ? 
                    <>
                        {
                            activeStep === 0 ?
                            <>
                                <TrainingInfo trainingData={trainingData} onTrainingDataChange={handleTrainingDataChange} />
                            </>
                            : null
                        }
                        {
                            activeStep === 1 ?
                            <>
                                <TrainingQuestion trainingData={trainingData} onTrainingDataChange={handleTrainingDataChange} reloadData={loadFolderData} />
                            </>
                            : null
                        }
                    </> : null
                }  
            </div>
            <footer className='control-footer'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div>
                        <Link to={'/exams'}>
                            <u>{t.buttons.exit_without_save}</u>
                        </Link>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button className='secondary' onClick={handleSaveDraft}>
                            {t.buttons.save_draft}
                        </button>
                        <button disabled={checkDisabled()} className='ms-2' onClick={handleNextStep}>
                            {activeStep === 1 ? t.buttons.save_and_pubblish : "Continua"} <img src={arrow_img} alt='' /> 
                        </button>
                    </div>
                </div>
            </footer>
            <ConfirmModal props={confirmModal}/>
        </section>
    )
}